import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.get-credit-card-account.views.StatementDetailsPanel`

export default defineMessages({
  panelTitle: {
    id: `${scope}.panelTitle`,
    defaultMessage: 'Statement details',
  },
  lastStatementDateLabel: {
    id: `${scope}.lastStatementDateLabel`,
    defaultMessage: 'Last statement date',
  },
  currentStatementDateLabel: {
    id: `${scope}.currentStatementDateLabel`,
    defaultMessage: 'Current statement date',
  },
  lastStatementBalanceLabel: {
    id: `${scope}.lastStatementBalanceLabel`,
    defaultMessage: 'Last statement balance',
  },
  statusLabel: {
    id: `${scope}.statusLabel`,
    defaultMessage: 'Status',
  },
  openStatus: {
    id: `${scope}.openStatus`,
    defaultMessage: 'Open',
  },
  draftStatus: {
    id: `${scope}.draftStatus`,
    defaultMessage: 'Draft',
  },
  submittedStatus: {
    id: `${scope}.submittedStatus`,
    defaultMessage: 'Submitted',
  },
  reconcileButton: {
    id: `${scope}.reconcileButton`,
    defaultMessage: 'Reconcile',
  },
  continueReconciliationButton: {
    id: `${scope}.continueReconciliationButton`,
    defaultMessage: 'Continue reconciliation',
  },
})
